import { i18n } from '@/plugins/i18n'

export const messageType ={
    SEND_CHANGE_PASSWORD: 'send_change_password',
    SEND_LOGINSUSPECTEDIPS: 'send_loginSuspectedIPs',
    SEND_NEWREGISTERSUSPECTEDIPS: 'send_newRegisterSuspectedIPs',
    SEND_SETTLEMENT: 'send_settlement',
    SEND_SUCCESSFUL_TRANSACTION: 'send_successful_transaction',
    SEND_TERMINAL_CHANGE_STATUS: 'send_terminal_change_status',
    SEND_TICKET_REPLY: 'send_ticket_reply',
    SEND_LOGIN_BOT_SUCCESS: 'send_login_bot_success',
    AUTH_DOCUMENT_REJECTED: 'auth_document_rejected',
    AUTH_DOCUMENT_VERIFIED: 'auth_document_verified',
    GATEWAY_REJECTED_BY_SHAPARAK: 'gateway_rejected_by_shaparak',
    GATEWAY_ACTIVATED: 'gateway_activated',
    ADMIN_TICKET_CREATED: 'admin_ticket_created',
    ADMIN_REPLIED_TICKET: 'admin_replied_ticket',
    MONEY_REQUEST_PAY_LINK: 'money_request_pay_link',
    MONEY_REQUEST_BILL_LINK: 'money_request_bill_link',
    FACTOR_SEND_LINK: 'factor_send_link',
    CHANGE_USER_LEVEL: 'change_user_level',
    SETTLEMENT_REJECTED: 'settlement_rejected',
    TRANSACTION_FAILED: 'transaction_failed',
    SEND_LOGIN_system_SUCCESS: 'send_login_system_success',
    SEND_WALLET_SETTLEMENT_SUCCESS: 'send_wallet_settlement_success',
    SEND_TICKET_NOTIFICATION_TO_ADMIN: 'send_ticket_notification_to_admin',
    SEND_FAILED_TRANSACTION_ALERT: 'send_failed_transaction_alert',
    SEND_MAX_FAILED_SETTLEMENT_TRANSACTIONS: "send_max_failed_settlement_transactions",
    SEND_ADMIN_WALLET_PENDING_SETTLEMENT: "send_admin_wallet_pending_settlement",
    SEND_WHEN_NOT_ENOUGH_BALANCE: "send_when_not_enough_balance",
    SWITCHED_WALLET_BANK_ACCOUNT : 'switched_wallet_bank_account',
    DISABLED_WALLET_BANK_ACCOUNT : 'disabled_wallet_bank_account',
    ACCOUNTING_RECORDS_DISCREPANCY : 'accounting_recorders_discrepancy',
    FAILED_OPEN_BANKING_REQUEST : 'failed_open_banking_request',
    FAILED_SCHEDULE_ALERT : 'failed_schedule_alert',
    CHANGE_ACCESS_NOTIFICATION : 'change_access_notification',
}

export const messageTypeStr = {
    SEND_CHANGE_PASSWORD: i18n.t('telegram_message_type.send_change_password'),
    SEND_LOGINSUSPECTEDIPS: i18n.t('telegram_message_type.send_loginSuspectedIPs'),
    SEND_NEWREGISTERSUSPECTEDIPS: i18n.t('telegram_message_type.send_newRegisterSuspectedIPs'),
    SEND_SETTLEMENT: i18n.t('telegram_message_type.send_settlement'),
    SEND_SUCCESSFUL_TRANSACTION: i18n.t('telegram_message_type.send_successful_transaction'),
    SEND_TERMINAL_CHANGE_STATUS: i18n.t('telegram_message_type.send_terminal_change_status'),
    SEND_TICKET_REPLY: i18n.t('telegram_message_type.send_ticket_reply'),
    SEND_LOGIN_BOT_SUCCESS: i18n.t('telegram_message_type.send_login_bot_success'),
    AUTH_DOCUMENT_REJECTED: i18n.t('telegram_message_type.auth_document_rejected'),
    AUTH_DOCUMENT_VERIFIED: i18n.t('telegram_message_type.auth_document_verified'),
    GATEWAY_REJECTED_BY_SHAPARAK: i18n.t('telegram_message_type.gateway_rejected_by_shaparak'),
    GATEWAY_ACTIVATED: i18n.t('telegram_message_type.gateway_activated'),
    ADMIN_TICKET_CREATED: i18n.t('telegram_message_type.admin_ticket_created'),
    ADMIN_REPLIED_TICKET: i18n.t('telegram_message_type.admin_replied_ticket'),
    MONEY_REQUEST_PAY_LINK: i18n.t('telegram_message_type.money_request_pay_link'),
    MONEY_REQUEST_BILL_LINK: i18n.t('telegram_message_type.money_request_bill_link'),
    FACTOR_SEND_LINK: i18n.t('telegram_message_type.factor_send_link'),
    CHANGE_USER_LEVEL: i18n.t('telegram_message_type.change_user_level'),
    SETTLEMENT_REJECTED: i18n.t('telegram_message_type.settlement_rejected'),
    TRANSACTION_FAILED: i18n.t('telegram_message_type.transaction_failed'),
    SEND_LOGIN_system_SUCCESS: i18n.t('telegram_message_type.send_login_system_success'),
    SEND_WALLET_SETTLEMENT_SUCCESS: i18n.t('telegram_message_type.send_wallet_settlement_success'),
    SEND_TICKET_NOTIFICATION_TO_ADMIN: i18n.t('telegram_message_type.send_ticket_notification_to_admin'),
    SEND_FAILED_TRANSACTION_ALERT: i18n.t('telegram_message_type.send_failed_transaction_alert'),
    SEND_MAX_FAILED_SETTLEMENT_TRANSACTIONS: i18n.t('telegram_message_type.send_max_failed_settlement_transactions'),
    SEND_ADMIN_WALLET_PENDING_SETTLEMENT: i18n.t('telegram_message_type.send_admin_wallet_pending_settlement'),
    SEND_WHEN_NOT_ENOUGH_BALANCE: i18n.t('telegram_message_type.send_when_not_enough_balance'),
    SWITCHED_WALLET_BANK_ACCOUNT : i18n.t('telegram_message_type.switched_wallet_bank_account'),
    DISABLED_WALLET_BANK_ACCOUNT : i18n.t('telegram_message_type.disabled_wallet_bank_account'),
    ACCOUNTING_RECORDS_DISCREPANCY: i18n.t('telegram_message_type.accounting_record_discrepancy'),
    FAILED_OPEN_BANKING_REQUEST: i18n.t('telegram_message_type.failed_open_banking_request'),
    FAILED_SCHEDULE_ALERT: i18n.t('telegram_message_type.failed_schedule_alert'),
    CHANGE_ACCESS_NOTIFICATION: i18n.t('telegram_message_type.change_access_notification'),

    get(type) {
        let type_str = null;
        Object.keys(messageType).forEach(function (item, index) {
            if(messageType[item] === type) {
                type_str = messageTypeStr[item]
            }
        })
        return type_str
    }
}

